export default "__VITE_PUBLIC_ASSET__1beb777c__"